<template>
	<div id="quick-bed-builder" @click.prevent="buckStopsHere">
		<div v-if="wallbed && wallbed.type == 'wallbed'">
			<div class="ekr-product-buttons">
				<div class="uk-flex uk-flex-middle">
					<a href="tel:8662572240" class="button gold">Most Popular</a>
					<button id="bb-enable" type="button" class="button outline" uk-toggle="target: #ww-builder-container" aria-haspopup="dialog" aria-controls="ww-builder-container">Custom Order</button>
				</div>
			</div>
		</div>
		<div class="product-panel">
			<div class="product-accordions">
				<ul v-if="wallbed && wallbed.type" ref="quickSteps" uk-accordion="">
					<SizeColor :color-only="wallbed.type == 'sofabed'"/>
					<SofaFabric v-if="wallbed.type == 'sofabed'"/>
					<LightsHeadboard v-if="wallbed.type == 'wallbed' || wallbed.type == 'sofabed'" 
						:display-number="wallbed.type == 'sofabed' ? 3:2"/>
					<SideCabinets v-if="wallbed.type == 'wallbed'  || wallbed.type == 'sofabed'" 
						:display-number="wallbed.type == 'sofabed' ? 4:3"/>
					<DeskLights v-if="wallbed.type == 'deskbed'" option-type="light" :display-number="2"/>
					<DeskLights v-if="wallbed.type == 'deskbed'" option-type="pillow" :display-number="3"/>
					<Mattress :display-number="wallbed.type == 'sofabed' ? 5:4"/>
				</ul>
				<ul v-else-if="isCabinetBed" ref="quickSteps" uk-accordion="">
					<CabinetBedColor />
					<CabinetBedOption v-for="(option, index) in additionalOptions" :key="'option_'+ index" :option="option" :display-number="index + 2" />
					<CabinetBedOption v-for="(option, index) in mattresses" :key="'option_'+ index" :option="option" :display-number="index + additionalOptions.length + 2" is-mattress="true" />
				</ul>
			</div>
			<CabinetBedCalculator v-if="isCabinetBed" />
			<div class="product-actions">
				<p class="total" aria-live="polite" aria-atomic="true">TOTAL
					<span v-if="buildTotals.discounts && buildTotals.discounts.length > 0" class="old-price">{{ buildTotals.originalPrice | currency }}</span>
					{{ buildTotals.total | currency }}</p>
				<button type="button" class="button blue addtocart" @click.prevent="addToCart">Add To Cart</button>

				<div v-if="productionTime" class="production-time-notice">
					<p>
						<i class="fa fa-truck" aria-hidden="true"></i>&nbsp;
						<b v-if="isMurphyCabinetBed">Delivered in: <span class="production-time">{{ productionTime }}</span></b>
						<b v-else>Custom built and delivered in: <span class="production-time">{{ productionTime }}</span></b>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapState} from 'vuex';
import SizeColor from "./quickComponents/SizeColor.vue";
import LightsHeadboard from "./quickComponents/LightsHeadboard.vue";
import SideCabinets from "./quickComponents/SideCabinets.vue";
import Mattress from "./quickComponents/Mattress.vue";
import DeskLights from "./quickComponents/DeskLights.vue";
import SofaFabric from "./quickComponents/SofaFabric.vue";
import CabinetBedColor from "./quickComponents/CabinetBedColor.vue";
import CabinetBedCalculator from "./quickComponents/CabinetBedCalculator.vue";
import CabinetBedOption from "./quickComponents/CabinetBedOption.vue";
export default {
	name: "QuickBuilder",

	props: {
		dataFailure: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Mattress,
		SideCabinets,
		LightsHeadboard,
		SizeColor,
		DeskLights,
		SofaFabric,
		CabinetBedColor,
		CabinetBedCalculator,
		CabinetBedOption
	},
	data() {
		return {
			selectedSizeId: null,
			dispNum: 0,
			productionTime: '',
			isMurphyCabinetBed: false,
		}
	},
	mounted() {
		if(this.wallbed || this.cabinetBed) {
			this.setAccordion();
		}
		this.tryProductionTime();
	},
	methods: {
		tryProductionTime(){
			if(typeof ajax_object == 'undefined'){
				setTimeout(() => this.tryProductionTime(), 100);
				return;
			}
			
			if(ajax_object && ajax_object.ajax_url){
				this.getProductionTime();
			} else {
				setTimeout(() => this.tryProductionTime(), 100);
			}
		},
		getProductionTime() {
			if (!this.product || !this.product.id) return;

			let formData = new FormData();
			formData.append('action', 'ww_get_production_time');
			formData.append('product_id', this.product.id);

			axios.post(ajax_object.ajax_url, formData)
				.then(response => {
					if (response.data && response.data.success && response.data.data) {
						this.productionTime = response.data.data.message || '';
						this.isMurphyCabinetBed = response.data.data.is_murphy_cabinet_bed || false;
					}
				})
				.catch(error => console.log(error));
		},
		/**
		 * get all items needed for pricing and send to cart.
		 */
		addToCart() {
			document.getElementById("builder-loader").setAttribute('class', 'on');
			// build data iobject
			let data = {};
			if(this.isCabinetBed){
				data = {
					style: this.cabinetBed.name,
					color: this.cabinetBedColor.name,
					type: "cabinet-bed",
					pricing: this.pricing_items,
					product: this.product.id,
					slug: this.cabinetBed.slug,
					options: [],
					mattress: this.selected_mattress ? this.selected_mattress.enabled_title : this.mattresses[0].disabled_title,
				};
			} else {
				data = {
					series: this.wallbed.series.name,
					style: this.wallbed.name,
					type: this.wallbed.type,
					pricing: this.pricing_items,
					product: this.product.id,
					slug: this.product.slug,
					size: this.selected_size.mattress_size.name,
					wood: (this.selected_wood != null) ? this.selected_wood.name : null,
					finish: (this.selected_finish != null) ? this.selected_finish.name : null,
					headboard: (this.selected_headboard != null) ? this.selected_headboard.name : null,
					desk_table: (this.selected_desk_table != null) ? this.selected_desk_table.front_panel_type.name : null,
					left_cabinet: null,
					right_cabinet: null,
					mattress: (this.selected_mattress != null) ? this.selected_mattress.name : null,
					options: []
				};
			}
			

			data.pricing.use_discounts = false;
			if (this.useDiscounts) {
				data.pricing.use_discounts = true;
			}

			// handle left cabinet
			if (this.selected_cabinet_left != null) {
				data.left_cabinet = {
					name: this.selected_cabinet_left.cabinet_type.name,
					size: this.selected_cabinet_left.width,
					nightstand: this.left_cabinet_night_tray,
					glass_doors: this.left_cabinet_glass_doors,
					glass_shelves: this.left_cabinet_glass_shelves
				};
			}
			// handle right cabinet
			if (this.selected_cabinet_right != null) {
				data.right_cabinet = {
					name: this.selected_cabinet_right.cabinet_type.name,
					size: this.selected_cabinet_right.width,
					nightstand: this.right_cabinet_night_tray,
					glass_doors: this.right_cabinet_glass_doors,
					glass_shelves: this.right_cabinet_glass_shelves
				};
			}

			// selected options
			if (this.selected_options.length > 0) {
				this.selected_options.forEach(row => {
					data.options.push(row.name);
				});
			}

			if (this.selected_fabric != null) {
				data.fabric = this.selected_fabric.name;
			}

			let formData = new FormData;
			formData.append('action', "ww_builder_add_to_cart");
			formData.append('nonce', this.wp_nonce);
			formData.append('data', JSON.stringify(data));

			//eslint-disable-next-line
			axios.post(ajax_object.ajax_url, formData)
				.then(response => this.handleAddToCart(response.data))
				//eslint-disable-next-line
				.catch(error => console.log(error));
		},
		/**
		 * check response
		 * @param  {[type]} response [description]
		 * @return {[type]}          [description]
		 */
		handleAddToCart(response) {
			if (response.success == true && response.data && response.data.success) {
				window.location.href = "/cart"; //go to the cart page
			} else {
				// eslint-disable-next-line no-console
				console.log(response);
				// eslint-disable-next-line no-undef
				document.getElementById("builder-loader").setAttribute('class', 'off');
				// eslint-disable-next-line no-undef
				UIkit.modal.alert("Sorry, we were unable to add the item to your cart at this time.");
			}
		},
		scrollToMenu(ev, titleItem) {
			setTimeout(function () {
				// eslint-disable-next-line no-undef
				let scrolling = UIkit.scroll(document.body, {duration: 200, offset: 60});
				scrolling.scrollTo(titleItem);
			}, 300);
		},
		buckStopsHere() {
			//this is just to place a prevent from clicks bubbling from here
			// eslint-disable-next-line
			//console.log("the buck has stopped.");
		},
		setAccordion() {
			if (!this.$refs.quickSteps) return;
			let subItems = this.$refs.quickSteps.getElementsByTagName("li");
			for (let i = 0; i < subItems.length; ++i) {
				let menuItem = subItems[i];
				let menuTitle = menuItem.querySelector(".uk-accordion-title");
				menuTitle.addEventListener("click", (e) => this.scrollToMenu(e, menuTitle));
			}
		}
	},
	computed: {
		...mapState({
			wallbed: state => state.wallbed,
			selected_size: state => state.selected_size,
			selected_wood: state => state.selected_wood,
			selected_finish: state => state.selected_finish,
			selected_headboard: state => state.selected_headboard,
			selected_desk_table: state => state.selected_desk_table,
			selected_options: state => state.selected_options,
			selected_cabinet_left: state => state.selected_cabinet_left,
			selected_cabinet_right: state => state.selected_cabinet_right,
			selected_mattress: state => state.selected_mattress,
			selected_fabric: state => state.selected_fabric,
			product: state => state.product,
			pricing_items: state => state.pricing_items,
			wp_nonce: state => state.wp_nonce,
			right_cabinet_night_tray: state => state.right_cabinet_night_tray,
			right_cabinet_glass_doors: state => state.right_cabinet_glass_doors,
			right_cabinet_glass_shelves: state => state.right_cabinet_glass_shelves,
			left_cabinet_night_tray: state => state.left_cabinet_night_tray,
			left_cabinet_glass_doors: state => state.left_cabinet_glass_doors,
			left_cabinet_glass_shelves: state => state.left_cabinet_glass_shelves,
			buildTotals: state => state.totals,
			useDiscounts: state => state.useDiscounts,
			cabinetBed: state => state.cabinetBed,
			additionalOptions: state => state.additional_options,
			mattresses: state => state.mattresses,
			cabinetBedColor: state => state.cabinetBedColor,
		}),
		isCabinetBed(){
			return this.cabinetBed && this.cabinetBed.type;
		}
	},
	watch: {
		wallbed(){
			setTimeout(() => this.setAccordion(), 2);
		},
		cabinetBed(){
			setTimeout(() => this.setAccordion(), 2);
		},
		product: {
			handler(newVal) {
				if (newVal && newVal.id) {
					this.getProductionTime();
				}
			},
			deep: true
		}
	}
}
</script>